var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHidePwd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hidePWD",
    transform: "translate(-10123 -12758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    transform: "translate(10123 12758)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "invisible",
    transform: "translate(10123 12727.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(0 32.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M231.147,160.069l3.436,3.436.016-.18a3.275,3.275,0,0,0-3.272-3.272Z",
    transform: "translate(-219.33 -153.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M154,66.781a5.455,5.455,0,0,1,5.453,5.453,5.369,5.369,0,0,1-.387,1.99l3.19,3.19A12.953,12.953,0,0,0,166,72.234a12.906,12.906,0,0,0-12-8.18,12.755,12.755,0,0,0-4.346.763l2.356,2.35A5.481,5.481,0,0,1,154,66.781Z",
    transform: "translate(-142.004 -62.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M1.091,33.444,3.577,35.93l.5.5A12.918,12.918,0,0,0,0,41.869a12.884,12.884,0,0,0,16.78,7.258l.464.464,3.179,3.185,1.391-1.385L2.481,32.053ZM7.122,39.47l1.685,1.685a3.456,3.456,0,0,0-.082.714A3.275,3.275,0,0,0,12,45.141a3.363,3.363,0,0,0,.709-.082l1.685,1.685A5.365,5.365,0,0,1,12,47.322,5.418,5.418,0,0,1,7.122,39.47Z",
    transform: "translate(0 -32.053)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePwd);
export default __webpack_public_path__ + "static/media/hidePWD.cb8bfd9f3f9133a18b87ac3b5da0137a.svg";
export { ForwardRef as ReactComponent };